import React from 'react';

function LikeButton({ likes, isLiked, onLike }) {
  return (
    <div className="like-section">
      <button 
        className={`like-btn ${isLiked ? 'liked' : ''}`}
        onClick={onLike}
      >
        {isLiked ? '❤️' : '🤍'} {likes}
      </button>
    </div>
  );
}

export default LikeButton;